import React, { useEffect } from 'react';
import { AppRoutes } from '../../appRoutes';
import { WsBonusShopOrder } from '../../../ws/result/WsBonusShopOrder';
import { BonusPoints } from '../../BonusPoints';
import { Store } from '../../../store';
import { OrderConfirmationPrintLayout } from './OrderConfirmationPrintLayout';
import { OrderConfirmationScreenLayout } from './OrderConfirmationScreenLayout';
import { useNavigate } from 'react-router-dom';

type OrderConfirmationPageStoreProps = { lastOrder: WsBonusShopOrder | null; points: BonusPoints };
export type OrderConfirmationPageProps = OrderConfirmationPageStoreProps;

export const UnconnectedOrderConfirmationPage: React.FC<OrderConfirmationPageProps> = ({ lastOrder, points }) => {
    const navigate = useNavigate();
    useEffect(() => {
        if (!lastOrder) navigate(AppRoutes.HOME);
    }, [lastOrder, navigate]);

    if (!lastOrder) return null;

    return (
        <>
            <OrderConfirmationScreenLayout lastOrder={lastOrder} />
            <OrderConfirmationPrintLayout lastOrder={lastOrder} points={points} />
        </>
    );
};

export const OrderConfirmationPage = Store.wire<OrderConfirmationPageStoreProps, Record<string, unknown>>(
    UnconnectedOrderConfirmationPage,
    ({ lastOrder, points }) => ({ lastOrder, points })
);
